import React, { useState } from 'react';
import { getMotivationalMessage } from '../openai';

function TeamMotivation({ horoscopes, members }) {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setError('');
    try {
      const msg = await getMotivationalMessage(horoscopes, members);
      setMessage(msg);
    } catch (e) {
      setError('ვერ მოხერხდა  მესიჯის მიღება.');
    }
    setLoading(false);
  };

  return (
    <div className="bg-[#232946] rounded-xl shadow p-6 mt-4 border border-orange-300">
      <button
        className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 mb-4 shadow"
        onClick={handleGenerate}
        disabled={loading}
      >
        სპრინტის პროგნოზის გენერირება
      </button>
      {loading && <div className="text-orange-200">იტვირთება...</div>}
      {error && <div className="text-red-400">{error}</div>}
      {message && <div className="mt-4 text-lg text-orange-100 whitespace-pre-line">{message}</div>}
    </div>
  );
}

export default TeamMotivation; 